import { createSlice } from "@reduxjs/toolkit";

const accountListSlice = createSlice({
  name: "accountList",
  initialState: [],
  reducers: {
    accountListAdded(state, action) {
      return action.payload;
    },
    accountListAddSpecific(state, action) {
      const account = action.payload;
      const accountIndex = state.findIndex(item => item.id === account.id);
      if (accountIndex === -1) {
        state.push(account);
      } else {
        state[accountIndex] = account;
      }
    },
    accountListRemoveSpecific(state, action) {
      return state.filter(account => account.id !== action.payload);
    },
  },
});

export const { accountListAdded, accountListAddSpecific, accountListRemoveSpecific } =
  accountListSlice.actions;
export default accountListSlice.reducer;
